module.exports = __webpack_public_path__ + "static/media/logo-si-pactt.e45a5e45.png";